import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
const SidebarLogo = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Link href="/dashboard" prefetch={false} className="flex cursor-pointer flex-nowrap items-center"><Image src="https://cdn.b3.fun/b3os-logo-embossed.png" alt="B3OS" width={134} height={28} className="h-7 w-auto opacity-90" priority={true} /></Link>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default SidebarLogo;